import React, { useState, useEffect } from 'react';
import './OfflinePage.css';

const OfflinePage = () => {
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    try {
      const offlineData = {
        timestamp: Date.now(),
        pageType: 'offline',
        lastAccessed: new Date().toISOString(),
        retryCount: retryCount
      };
      
      localStorage.setItem('offlinePageData', JSON.stringify(offlineData));
      setIsStored(true);
      
      localStorage.setItem('isOffline', 'true');
    } catch (error) {
      console.warn('Failed to store offline data:', error);
    }
  }, [retryCount]);

  useEffect(() => {
    try {
      const storedData = localStorage.getItem('offlinePageData');
      if (storedData) {
        const data = JSON.parse(storedData);
        setRetryCount(data.retryCount || 0);
        console.log('Offline data loaded from storage:', data);
      }
    } catch (error) {
      console.warn('Failed to load stored offline data:', error);
    }
  }, []);
  
  return (
      <div className="offline-screen">
        <div className="offline-wrapper">
          <div className="wifi-off-icon">
            <svg width="270" height="270" viewBox="1 0 24 24" fill="none">
              <path d="M5 8.5C7.5 6.5 10.5 5.5 13.5 5.5C16.5 5.5 19.5 6.5 22 8.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>

              <path d="M8 12C9.5 11 11.5 10.5 13.5 10.5C15.5 10.5 17.5 11 19 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>

              <path d="M11 15.5C11.8 15 12.8 14.8 13.8 14.8C14.8 14.8 15.8 15 16.5 15.5" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>

              <circle cx="13.5" cy="19.5" r="1.5" fill="currentColor"/>

              <path d="M2 1L22 20" stroke="red" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>

          <h1 className="offline-title">
            Пайвастшавӣ ба интернет<br />мавҷуд нест
          </h1>
        </div>
      </div>
  );
};

export default OfflinePage;